export const getInputConfig = ({ survey, surveyType, style }) => {
  if (surveyType === 'poll') {
    return {
      survey,
      maxQuestions: 1,
      maxQuestionsBasic: 10,
      types: ['poll'],
      selectedType: surveyType,
      showBadge: false,
      sendPayloadOnAllUpdates: false,
      hideCreateSurveyButton: false,
      hideCancelSurveyButton: true,
      style,
    };
  }
  return {
    survey,
    maxQuestions: 20,
    maxQuestionsBasic: 10,
    types: ['Survey', 'Quiz'],
    selectedType: surveyType,
    showBadge: false,
    sendPayloadOnAllUpdates: false,
    hideCreateSurveyButton: false,
    hideCancelSurveyButton: true,
    style,
  };
};

export default getInputConfig;
